// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"c25f5f7e","769":"1c2e6202"}[chunkId] + ".chunk.js";
};